import React from 'react';
import leaf1 from '../../images/loadingLeaf1.png';
import leaf2 from '../../images/loadingLeaf2.png';
import leaf3 from '../../images/loadingLeaf3.png';

const LeafLoader = ({
                        leafImages = [leaf1, leaf2, leaf3],
                        count = 6,
                        size = 24,
                        speed = 'medium',
                        radius = 40,
                        top = '50%',
                    }) => {
    const speeds = {
        slow: { orbit: 4, flutter: 2 },
        medium: { orbit: 3, flutter: 1.5 },
        fast: { orbit: 1.4, flutter: 1 }
    };

    const currentSpeed = speeds[speed] || speeds.medium;

    const defaultLeaf = (
        <div
            className="bg-green-500"
            style={{
                width: size,
                height: size,
                clipPath: 'ellipse(40% 50% at 30% 50%)'
            }}
        />
    );

    const leaves = Array.from({ length: count }, (_, i) => {
        const angle = (360 / count) * i;
        const delay = i * 0.2;
        const leafImage = leafImages[i % leafImages.length];

        return (
            <div
                key={i}
                className="leaf-orbit"
                style={{
                    animationDelay: `${delay}s`,
                    animationDuration: `${currentSpeed.orbit}s`,
                    transform: `rotate(${angle}deg)`,
                }}
            >
                <div
                    className="leaf-item"
                    style={{
                        animationDelay: `${delay * 0.5}s`,
                        animationDuration: `${currentSpeed.flutter}s`,
                    }}
                >
                    {leafImage ? (
                        <img
                            src={leafImage}
                            alt="leaf"
                            className="w-full h-full object-contain"
                            style={{ width: size, height: size }}
                        />
                    ) : (
                        defaultLeaf
                    )}
                </div>
            </div>
        );
    });

    return (
        <div className="relative inline-block">
            <style
                dangerouslySetInnerHTML={{
                    __html: `
            .leaf-orbit {
              position: absolute;
              left: 50%;
              top: ${top};
              margin-left: -${size / 2}px;
              margin-top: -${size / 2}px;
              transform-origin: center;
              opacity: 0;
              animation: orbitRotate ${currentSpeed.orbit}s linear infinite, fadeInLeaf 0.1s ease-in forwards;
            }

            .leaf-item {
              transform: translateX(${radius}px);
              animation: leafFlutter ${currentSpeed.flutter}s ease-in-out infinite;
            }
            
            @keyframes fadeInLeaf {
              0% { opacity: 0; }
              100% { opacity: 1; }
            }

            @keyframes orbitRotate {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }

            @keyframes leafFlutter {
              0%, 100% {
                transform: translateX(${radius}px) scale(1) rotateZ(0deg);
              }
              25% {
                transform: translateX(${radius}px) scale(1.1) rotateZ(5deg);
              }
              50% {
                transform: translateX(${radius}px) scale(0.9) rotateZ(-3deg);
              }
              75% {
                transform: translateX(${radius}px) scale(1.05) rotateZ(2deg);
              }
            }
          `
                }}
            />

            <div
                className="relative"
                style={{
                    width: (radius + size) * 2,
                    height: (radius + size) * 2
                }}
            >
                {leaves}
            </div>
        </div>
    );
};

export default LeafLoader;